import { useTranslation } from 'react-i18next';

import { sliceInputText } from '../../utils/sliceInputMap';

import { Badge } from '@/components/ui/Badge';
import { MerchandisingCollectionSlice } from '@/services/MerchandisingCollectionsService';

interface SliceTagsProps {
  slice: MerchandisingCollectionSlice;
}

export function SliceTags({ slice }: SliceTagsProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.MerchandisingCollections.components.SliceTags',
  });

  return (
    <div className="flex flex-wrap gap-2">
      {slice.inputType && (
        <Badge variant="secondary">
          {t('type')}: {sliceInputText(slice.inputType)}
        </Badge>
      )}

      {Object.entries(slice?.filters ?? {}).map(([key, value]) => {
        if (!value.active) {
          return null;
        }

        return (
          <Badge key={key} variant="secondary">
            {t('filter')}: {key}
          </Badge>
        );
      })}
    </div>
  );
}
